const ALLOWED_FILE_TYPES = ['image/*', '.jpg', '.jpeg', '.png']

export default { ALLOWED_FILE_TYPES }
